// Prekės ženklo konfigūracija per runtime env.
//
// Produkcija (imre2.lt) env nenustato → naudojamos numatytosios „Imrė" reikšmės,
// tad išvaizda nepakinta. Demo egzempliorius nustato BRAND_* env kintamuosius ir
// gauna neutralų ženklą — TA PATI kodų bazė / tas pats Docker image tinka abiem.
//
// SVARBU: NEXT_PUBLIC_* Next.js įkalamas BUILD metu, todėl jo NENAUDOJAM.
// Serveris skaito process.env runtime metu; klientui reikšmės perduodamos per
// window.__BRAND__, kurį įpurškia šakninis layout (žr. app/layout.tsx).

export type QuickLoginAccount = {
  name: string;
  email: string;
  badge: string;
};

export type BrandConfig = {
  /** Programos pavadinimas, pvz. „ImreApp" */
  appName: string;
  /** Įmonės (paslaugų teikėjo) pavadinimas, pvz. „Imrė" */
  name: string;
  /** Etiketė paslaugų teikėjo atsakingam asmeniui, pvz. „Imrės atsakingas asmuo" */
  responsibleLabel: string;
  /** APK gamybos serverio adresas (rodomas /idiegti) */
  apkHost: string;
  /** Greito personalo prisijungimo sąrašas (login puslapyje) */
  quickLogin: QuickLoginAccount[];
};

const DEFAULT_QUICK_LOGIN: QuickLoginAccount[] = [
  { name: 'Aurimas Zakarauskas', email: 'aurimas@imre.lt', badge: 'DIR' },
  { name: 'Robertas Trinkūnas', email: 'statyba@imre.lt', badge: 'ADMIN' },
  { name: 'Gintarė Imrė', email: 'gintare@imre.lt', badge: 'ADMIN' },
];

export const BRAND_DEFAULTS: BrandConfig = {
  appName: 'ImreApp',
  name: 'Imrė',
  responsibleLabel: 'Įmonės atsakingas asmuo',
  apkHost: 'imre2.indevi.eu',
  quickLogin: DEFAULT_QUICK_LOGIN,
};

/**
 * Serverio pusė: skaito runtime env. Naudoti server komponentuose,
 * generateMetadata, route handler'iuose ir layout injekcijai.
 */
export function getServerBrand(): BrandConfig {
  let quickLogin = DEFAULT_QUICK_LOGIN;
  const rawQuick = process.env.BRAND_QUICK_LOGIN;
  if (rawQuick) {
    try {
      const parsed = JSON.parse(rawQuick);
      if (Array.isArray(parsed)) quickLogin = parsed;
    } catch {
      // netinkamas JSON — paliekam numatytąjį
    }
  }
  return {
    appName: process.env.BRAND_APP_NAME || BRAND_DEFAULTS.appName,
    name: process.env.BRAND_NAME || BRAND_DEFAULTS.name,
    responsibleLabel: process.env.BRAND_RESPONSIBLE_LABEL || BRAND_DEFAULTS.responsibleLabel,
    apkHost: process.env.BRAND_APK_HOST || BRAND_DEFAULTS.apkHost,
    quickLogin,
  };
}

/**
 * Kliento pusė: skaito window.__BRAND__ (įpurkšta layout'o). Jei nėra —
 * grąžina numatytąsias reikšmes. Saugu kviesti ir serveryje (grąžins defaults).
 */
export function getBrand(): BrandConfig {
  if (typeof window !== 'undefined') {
    const injected = (window as unknown as { __BRAND__?: Partial<BrandConfig> }).__BRAND__;
    if (injected) return { ...BRAND_DEFAULTS, ...injected };
  }
  return BRAND_DEFAULTS;
}
